import axios from 'axios'
import { unref } from 'vue'

import { useContext } from './context'
import { tripQueryKeys } from './trip'
import { useMutation, useQueryClient } from '@/composables/vue-query'
import { MaybeRef } from '@/types/types'
import { eventModule } from '@/store'

export function useInviteUser(tripId: MaybeRef<string>) {
  const { $axios } = useContext()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (emailOrUsername: string) => {
      await $axios.post(`/api/trips/${unref(tripId)}/invite`, {
        value: emailOrUsername,
      })

      eventModule.newMessage('success.trip.invite')
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: tripQueryKeys.detail(tripId),
      })
      await queryClient.invalidateQueries({
        queryKey: tripQueryKeys.itinerary(tripId),
      })
    },
    onError: (error) => {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        eventModule.newError('error.user.search')
      } else {
        eventModule.newError('error.trip.invite')
      }
    },
  })
}

export function useRemoveUser(tripId: MaybeRef<string>) {
  const { $axios } = useContext()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (userId: string) => {
      await $axios.post(`/api/trips/${unref(tripId)}/leave/${userId}`)
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: tripQueryKeys.detail(tripId),
      })
      await queryClient.invalidateQueries({
        queryKey: tripQueryKeys.itinerary(tripId),
      })
    },
    onError: () => {
      eventModule.newMessage('error.trip.leave')
    },
  })
}
